import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import { bobbeeDarkTheme, bobbeeLightTheme } from '../../theme/bobbeeTheme';

const bobbeeLight = ThemeBlueprint.make({
  name: 'bobbee-light',
  params: {
    theme: {
      id: 'bobbee-light',
      title: 'Clair',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={bobbeeLightTheme} children={children} />
      ),
    },
  },
});

const bobbeeDark = ThemeBlueprint.make({
  name: 'bobbee-dark',
  params: {
    theme: {
      id: 'bobbee-dark',
      title: 'Sombre',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={bobbeeDarkTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [bobbeeLight, bobbeeDark],
});
